import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import AuthContext from "./AuthContext";
import { loginPathWithNext } from "./redirect";

const AdminRoute = ({ children }) => {
  const { auth, user } = useContext(AuthContext);
  const location = useLocation();

  if (!auth?.user) {
    return <Navigate to={loginPathWithNext(location.pathname, location.search)} replace />;
  }

  if (!user?.is_admin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
